import React, { Component } from 'react'
import numeral from 'numeral';
import InputForm from '../InputForm/InputForm'
import './DiscountCode.css'
import { searchDiscountCode } from './searchDiscountCode';
import { setURLParams } from '../../../Helpers/setURLParams';
import { localstorageCRUD } from '../../../Scripts/localstorageCRUD';

export default class DiscountCode extends Component {

  state={
    discount_success: null,
    discount_value: null,
    old_total_price: null,
    new_total_price: null,
  }

  componentDidMount=()=>{
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const discount_code = params.get("discount_code");
    if(discount_code!==undefined && discount_code!==null && discount_code!==""){
      const input = document.getElementById('discount_code');
      input.value = discount_code;
      this.applyDiscount(null, "url", discount_code)
    }
  }

  componentDidUpdate=(prevProps, prevState)=>{
    const {selectedPackData, discount_code} = this.props
    if(selectedPackData !== prevProps.selectedPackData || discount_code !== prevProps.discount_code){
      this.applyDiscount(null, "url", discount_code)
    }
  }

  typing=(e)=>{
    const {onChange} = this.props
    this.setState({
      discount_success: null,
      discount_value: null
    })
    onChange(e)
  }

  applyDiscount=async(e, from, url_discount_code)=>{
    const {discount_code, selectedPackData} = this.props
    let aux_discount_code = null;
    if(from==="url"){
      aux_discount_code = url_discount_code
    } else {
      aux_discount_code = discount_code
      e.preventDefault()
    }
    let res = await searchDiscountCode(aux_discount_code)
    if(res.success === true){
      setURLParams("discount_code", aux_discount_code)
      setURLParams("discount_value", res.discountCodeData.discount_value)
      this.props.setDiscountValue(res.discountCodeData.discount_value)
      
      let old_total_price = selectedPackData.comparative_price - selectedPackData.discount
      let new_total_price = selectedPackData.comparative_price - selectedPackData.discount - parseInt(res.discountCodeData.discount_value)
      
      this.setState({
        discount_success: true, 
        discount_value: parseInt(res.discountCodeData.discount_value), 
        old_total_price,
        new_total_price,
      })

      // setURLParams("discount_code", aux_discount_code)
      // setURLParams("discount_value", res.discountCodeData.discount_value)
      // this.props.setDiscountValue(res.discountCodeData.discount_value)
    } else {
      this.setState({discount_success: false})
    }
  }


  render() {
    const {discount_code, onChange} = this.props
    const {discount_success, discount_value, new_total_price, old_total_price} = this.state
    return (
        <div className='DiscountCode'>
            <div className='d-flex align-items-center'>
                <InputForm 
                input_required={false} 
                input_value={discount_code} 
                input_type={"text"} 
                with_label_text={true} 
                label_text={"Ingresa un codigo de descuento"} 
                label_htmlFor={"discount_code"} 
                with_small_text={false} 
                small_text={null} 
                input_id={"discount_code"} 
                input_placeholder={"Codigo de descuento"} 
                onChange={this.typing}/>

                <button className='DiscountCode_btn' onClick={this.applyDiscount}>
                  Aplicar
                </button>
            </div>

            <div className='DiscountCode_response'>
              {discount_success!==null?
                  discount_success===true?
                  <div>
                    <div className='DiscountCode_success_value'>
                      <div style={{marginBottom:"10px", fontWeight:"bolder"}}>
                        Tu bono ha sido aplicado correctamente
                      </div>

                      {/* <div className='d-flex'>
                        Sin el bono pagabas
                        <div style={{marginLeft:"auto"}}>{numeral(old_total_price).format('$ 0,0[.]00')}</div> 
                      </div> 
                      <div className='d-flex'>
                        Valor del bono 
                        <div style={{marginLeft:"auto"}}>- {numeral(discount_value).format('$ 0,0[.]00')}</div> 
                      </div> */}

                      <div className='d-flex'>
                        Ahora solo pagaras 
                        <div style={{marginLeft:"auto"}}>= {numeral(new_total_price).format('$ 0,0[.]00')}</div> 
                      </div>

                    </div>
                  </div>
                  :
                  <div className='DiscountCode_error'>Ingresa un codigo valido</div>
              :null}
            </div>
        </div>
    )
  }
}
